/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shot_Change_SettingsInputs */



/**
* | output |
* | --- |
* | "Shot change settings" |
*
* @param {Shot_Change_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shot_change_settings = /** @type {((inputs?: Shot_Change_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shot_Change_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de changement de plan")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen ändern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di modifica dello scatto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменение настроек съемки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustes de cambio de toma")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拍摄设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショット変更設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट बदलने की सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterar configurações de disparo")
	return /** @type {LocalizedString} */ ("Shot change settings")
});